import styled from 'styled-components';

//Example use at Acronis modal at asset summary
const SummaryDetailsModal = styled.div`
  .card-container {
    overflow: auto;
  }
  .icon-card-circle {
    margin-right: 10px;
    width: 82px;
    height: 82px;
    background: rgba(233, 233, 249, 0.3);
    border-radius: 50%;
  }
  .detail-name {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 20px;
  }
  .status {
    color: #0b0114;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .top-container {
    margin-bottom: 15px;
    width: 100%;
  }

  .separator {
    margin: 0px 10px;
  }
  .icon-lg {
    width: 120px;
    height: 90px;
  }
`;

const SummaryMoreDetailsWrapper = styled.div`
  background-color: #eaeafa77;
  padding: 25px 40px 15px 40px;
  border-radius: 10px;
  .danger {
    color: #ed0050;
  }
  .success {
    color: #00d247;
  }
  .label {
    width: 15%;
    margin-right: 20px;
    text-align: right;
  }
`;

export { SummaryDetailsModal, SummaryMoreDetailsWrapper };